import { showLoadingIndicator } from '../actions/loginActions';

export const fetchApi = (dispatch, endpoint, params, ...callbacks ) => {

  let { onSuccess, onFailed, onError } = callbacks[0];
  //dispatch( showLoadingIndicator(true) );

setTimeout(function(){

  fetch(endpoint, {
    method: 'POST',
    headers: {'Content-Type':'application/x-www-form-urlencoded'},
    //mode: 'no-cors',
    body: params
  })
    .then((response) => {
      console.log(response);
      //dispatch( showLoadingIndicator(false) );
      if (response.ok){
        response.json().then((response) => {
             if (response.status == "OK" || response.status == "PENDING") {
               onSuccess(response);
             } else if (response.status == "ERROR"){
               onFailed(response);
             }
         });
      }else {
        let status = response.status;
        response.text().then((textResponse) => {
          console.log('failed ', response);
          onError(textResponse);
        });
      }
    })
    .catch((error) => {
      //dispatch( showLoadingIndicator(false) );
      let err = error.message ? error.message : error;
      onError(err);
    })

  }, 5000);
}

export const fetchApi2 = (endpoint, params, ...callbacks) =>
  fetch(endpoint, {
    method: 'POST',
    headers: {'Content-Type':'application/x-www-form-urlencoded'},
    body: params
  });



// WEBPACK FOOTER //
// ./src/api/index.js